import React from "react";
import { Button } from "../shared/Button";
import { Carousel } from "react-bootstrap";
import styles from "./NewsModal.module.scss";
import { ISODateToSpanish } from "../../utilities/dateFormatter";
import CloseBoxIcon from "../icons/BtnCloseSquared";
import SwapIcon from "../icons/SwapIcon";

const NewsModal = ({ isOpen, newsItem, handleCloseModal }) => {
  if (!isOpen) return null;
  const baseURL = window.location.origin;

  const images = [{id: 0, url: newsItem.mainImage}, ...(newsItem.images || [])];
  const articleUrl = `${baseURL}/news/${newsItem.id}`;

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.modalClose}>
          <Button color="text" onClick={handleCloseModal} className={styles.closeNewModal}>
            <CloseBoxIcon width={44} height={44} />
          </Button>
        </div>

        <div className={styles.modalContent}>
          <span className={styles.date}>{ISODateToSpanish(newsItem.createdAt)}</span>
          <h2 className={styles.title}>{newsItem.title}</h2>
          <p className={styles.description}>{newsItem.description}</p>
          <div className={styles.categoryContainer}>
            <p className={styles.category}>{newsItem.category.name}</p>
          </div>
          <div className={styles.carouselWrapper}>
            <Carousel indicators={images.length > 1}>
              {images.map((img, index) => (
                <Carousel.Item key={index}>
                  <img
                    src={img.url}
                    className="d-block w-100"
                    alt={`Slide ${index + 1}`}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>

          {newsItem.tag && <span className={styles.tag}>{newsItem.tag}</span>}

          {newsItem.content && (
            <div
              className={styles.richText}
              dangerouslySetInnerHTML={{ __html: newsItem.content }}
            />
          )}

          <div className={styles.footer}>
            <button className={styles.shareButton} onClick={() => navigator.clipboard.writeText(articleUrl)}>
              <SwapIcon width={24} height={24} stroke="#000" /> Compartir link
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsModal;